
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../../node_modules/core-js/modules/es.array.concat.js';
import '../../../../node_modules/core-js/modules/es.array.every.js';
import '../../../../node_modules/core-js/modules/es.array.includes.js';
import '../../../../node_modules/core-js/modules/es.array.join.js';
import '../../../../node_modules/core-js/modules/es.array.map.js';
import '../../../../node_modules/core-js/modules/es.array.reduce.js';
import '../../../../node_modules/core-js/modules/es.object.keys.js';
import '../../../../node_modules/core-js/modules/es.object.to-string.js';
import '../../../../node_modules/core-js/modules/es.string.includes.js';
import { useState, useEffect, useCallback } from 'react';
import classNames from '../../../../node_modules/classnames/index.js';
import Checkbox from '../../FormElements/CheckboxGroup/Checkbox.js';
import SvgIconChevronDown from '../../../icons/chevrons/icon-chevron-down.svg.js';
import SvgIconChevronUp from '../../../icons/chevrons/icon-chevron-up.svg.js';
import { Actions } from '../constants.js';
import Cell from './Cell.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var rowClassnames = function rowClassnames(isSelectAllChecked, allRowsSelected, autohide) {
  return classNames({
    selected: isSelectAllChecked || allRowsSelected,
    "autohide-cell": autohide
  });
};
var sortingIconClassNames = function sortingIconClassNames(isDefaultSort) {
  return classNames("sorting-icon", {
    "is-default-sort": isDefaultSort
  });
};
var Header = function Header(_ref) {
  var _ref$selectable = _ref.selectable,
    selectable = _ref$selectable === void 0 ? false : _ref$selectable,
    _ref$autohide = _ref.autohide,
    autohide = _ref$autohide === void 0 ? false : _ref$autohide,
    state = _ref.state,
    dispatch = _ref.dispatch,
    onSortingChanged = _ref.onSortingChanged,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    id = _ref.id;
  var rows = state.rows,
    columns = state.columns,
    selected = state.selected,
    sorting = state.sorting;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    columnsSorting = _useState2[0],
    setColumnsSorting = _useState2[1];
  var selectedIds = selected.map(function (entry) {
    return entry.id;
  });
  var rowIds = rows.map(function (row) {
    return row.id;
  });
  var isSelectAllChecked = selected.length > 0;
  var allRowsSelected = rowIds.every(function (rowId) {
    return selectedIds.includes(rowId);
  });
  var hasSorting = Object.keys(sorting || {}).length > 0;
  useEffect(function () {
    var sortingPerColumn = columns.reduce(function (acc, column) {
      var isDefault = (sorting === null || sorting === void 0 ? void 0 : sorting.column) === column.accessor;
      acc[column.accessor] = {
        column: column.accessor,
        isDescending: isDefault ? sorting.isDescending : column.sortOrder === "desc"
      };
      return acc;
    }, {});
    setColumnsSorting(sortingPerColumn);
  }, [sorting]);
  var handleToggleSelectAll = useCallback(function (e) {
    if (disabled) return;
    e.preventDefault();
    dispatch({
      type: Actions.toggleAll,
      payload: null
    });
  }, [dispatch, disabled]);
  var handleSortingChange = function handleSortingChange(accessor, sortOrder) {
    if (disabled) return;
    if (hasSorting) {
      var isDefaultSort = (sorting === null || sorting === void 0 ? void 0 : sorting.column) === accessor;
      var isDescendingOrder = sortOrder === "desc";
      setColumnsSorting(_objectSpread2(_objectSpread2({}, columnsSorting), {}, _defineProperty({}, accessor, {
        column: accessor,
        isDescending: isDefaultSort ? !sorting.isDescending : isDescendingOrder
      })));

      // When a new column is clicked to sort, apply the default sortOrder in the columns array.
      // When we select the same column (the default sort column) change it's current order to the opposite.
      var newSorting = {
        column: accessor,
        isDescending: isDefaultSort ? !sorting.isDescending : isDescendingOrder
      };
      dispatch({
        type: Actions.sortingChanged,
        payload: newSorting
      });
      onSortingChanged && onSortingChanged(newSorting);
    }
  };
  return jsx("thead", null, jsx("tr", {
    className: rowClassnames(isSelectAllChecked, allRowsSelected, autohide)
  }, selectable && jsx(Cell, {
    as: "td",
    className: "selectable-cell"
  }, jsx(Checkbox, {
    id: "select-all-".concat(isSelectAllChecked, " - ").concat(id),
    name: "select-all",
    "aria-label": "Select all rows",
    value: "all",
    onChange: handleToggleSelectAll,
    checked: isSelectAllChecked,
    isPartiallySelected: !allRowsSelected,
    disabled: disabled
  })), columns.map(function (_ref2) {
    var _columnsSorting$acces;
    var accessor = _ref2.accessor,
      cell = _ref2.cell,
      hidden = _ref2.hidden,
      _ref2$sortableHeader = _ref2.sortableHeader,
      sortableHeader = _ref2$sortableHeader === void 0 ? true : _ref2$sortableHeader,
      _ref2$classNames = _ref2.classNames,
      classNames = _ref2$classNames === void 0 ? [] : _ref2$classNames,
      sortOrder = _ref2.sortOrder,
      headerWidth = _ref2.headerWidth;
    return !hidden && jsx(Cell, {
      as: cell ? "th" : "td",
      key: accessor,
      "data-testid": "".concat(accessor, "-column"),
      maxWidth: headerWidth,
      className: "header-cell ".concat(classNames.length > 0 && classNames.join(" "), " ").concat(!sortableHeader ? "hidden" : ""),
      onClick: function onClick() {
        if (!disabled && sortableHeader) {
          handleSortingChange(accessor, sortOrder);
        }
      }
    }, jsx("span", null, typeof cell === "string" ? cell : cell({
      accessor: accessor,
      cell: cell
    })), hasSorting && sortableHeader && jsx("span", {
      className: sortingIconClassNames(accessor === (sorting === null || sorting === void 0 ? void 0 : sorting.column)),
      "data-testid": "".concat(accessor, "-sorting")
    }, (_columnsSorting$acces = columnsSorting[accessor]) !== null && _columnsSorting$acces !== void 0 && _columnsSorting$acces.isDescending ? jsx(SvgIconChevronDown, {
      height: 20
    }) : jsx(SvgIconChevronUp, {
      height: 20
    })));
  })));
};

export { Header as default };
//# sourceMappingURL=Header.js.map
